import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "parent" }
const _hoisted_2 = { class: "textInput" }
const _hoisted_3 = {
  key: 0,
  class: "label",
  for: "tbox1"
}
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($props.Title)
        ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString($props.Title), 1))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        class: _normalizeClass(["input", { errorStyle: $props.error }]),
        type: "number",
        id: "tbox1",
        name: "tbox1",
        value: $props.Value,
        min: "1",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onChangeVal', $options.handleEmit($event.target)))),
        required: ""
      }, null, 42, _hoisted_4),
      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1))
    ])
  ]))
}